import { render, staticRenderFns } from "./ComplexTable.vue?vue&type=template&id=22081a90&"
import script from "./ComplexTable.vue?vue&type=script&lang=js&"
export * from "./ComplexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports